import React from 'react'
import styles from './ApproachesDEtails.module.css'
import tree1 from "../../assets/Tree.svg"
import tree2 from "../../assets/tree2.png"
import tree3 from "../../assets/tree3.png"
import tree4 from "../../assets/tree4.png"
import tree5 from "../../assets/tree5.png"
function ApproacheDetails() {
  return (
    <div className={styles.ApproacheDetails}>
      <div className={styles.approach}>
        <div data-aos='slide-right' className={styles.ApproacheDetailsLeft}>
          <div className={styles.treediv}>
            <img src={tree1} alt="" />
          </div>
        </div>
        <div className={styles.ApproacheDetailsRight}>
          <div data-aos='slide-left' className={styles.ApproacheRightHead}>
            <h3>現状把握</h3>

          </div>
          <div className={styles.ApproacheParaLeft}>
            <div className={styles.ApproacheDiv}>
              <p>そもそもどういった事業環境なのか。そもそも抱えている問題は何か。<br />
                問題はどうのようにして起こっているのか。そういった情報を整理します。 <br />
                現状把握においては、非常に重要になってくるのが、情報の収集とその分析です。<br />
                その点においては、弊社の経験豊富なアナリストが大量の情報を収集し、それらを <br /> 整理していきます。<br />
                現状把握こそ、問題を解決する流れの中でも最も重要になってくる段階だと我々は考えています。</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.approach}>

        <div data-aos='slide-right' className={styles.ApproacheDetailsLeft}>
          <div className={styles.treediv2}>
            <img src={tree5} alt="" />
          </div>
        </div>
        <div className={styles.ApproacheDetailsRight}>
          <div data-aos='slide-left' className={styles.ApproacheRightHead}>
            <h3>問題の定義</h3>

          </div>
          <div className={styles.ApproacheParaLeft}>
            <div className={styles.ApproacheDiv}>
              <p>現状の把握をさせていただいた上で、実際に解決するべき問題が何かを定義します。<br />
                顧客が感じている問題と、実際に解決すべき問題は異なる場合もあります。<br />
                何が原因で、現状の不便さ、つまり、問題が解決しているのかをはっきりとさせなけ <br /> れば、どんな解決策、ITソリューションを開発しても効果的でありません。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.approach}>
        <div data-aos='slide-right' className={styles.ApproacheDetailsLeft}>
          <div className={styles.treediv3}>
            <img src={tree4} alt="" />
          </div>
        </div>
        <div className={styles.ApproacheDetailsRight}>
          <div data-aos='slide-left' className={styles.ApproacheRightHead}>
            <h3>解決策の設計</h3>

          </div>
          <div className={styles.ApproacheParaLeft}>
            <div className={styles.ApproacheDiv}>
              <p>解決すべき問題が定義できたところから始まります。<br />
                現状の解決すべき問題に対してアプローチする方法は無数に検討できます。<br />
                それらの検討できる選択肢についてそれぞれ思考し、効率よくゴールに辿り着く方 <br /> 法を設計していきます。
                当グループが特に焦点を当てている考え方は、先を見据えた解決策を設計し、実行 <br /> することです。
                先を見据えるということは、実装後の状況の分析、修正も視野に入れた解決策を設 <br /> 計するということです。</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.approach}>
        <div data-aos='slide-right' className={styles.ApproacheDetailsLeft}>
          <div className={styles.treediv4}>
            <img src={tree3} alt="" />
          </div>
        </div>
        <div className={styles.ApproacheDetailsRight}>
          <div data-aos='slide-left' className={styles.ApproacheRightHead}>
            <h3>解決策の実行</h3>

          </div>
          <div className={styles.ApproacheParaLeft}>
            <div className={styles.ApproacheDiv}>
              <p>緻密に設計した解決策を実行します。<br />
                実行すると言っても単なる実行ではなく、検証、修正を加味した実行です。<br />
                実行しただけでゴールではなく、実際に導入し、稼働させるところが始まりとな <br /> り、最適な解決を実現します。<br />
                解決策の実行を開始してから、関連する数値の分析に入ります。。</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.approach}>
        <div data-aos='slide-right' className={styles.ApproacheDetailsLeft}>
          <div className={styles.treediv5}>
            <img src={tree2} alt="" />
          </div>
        </div>
        <div className={styles.ApproacheDetailsRight}>
          <div data-aos='slide-left' className={styles.ApproacheRightHead}>
            <h3>検証・修正</h3>

          </div>
          <div className={styles.ApproacheParaLeft}>
            <div className={`${styles.lastPara}`}>
              <p>当グループの強みとして挙げられる観点がこの段階に大きく含まれます。<br />
                依頼を受けたシステムなどの実行だけでなく、実行したのちにそれらがどのような <br /> 影響を与えているのかを分析していきます。<br />
                生き物と同じく、実際に実行してみないとわからないこともあります。<br />
                それらの事柄を検証を前提に実行し、修正していきます。</p>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}

export default ApproacheDetails